import {IVanillaReaderUI} from "./IVanillaReaderUI";
import {VanillaReaderUI} from "./VanillaReaderUI";
import {IVisibleContentRectData} from "@colibrio/colibrio-reader-framework/colibrio-readingsystem-base";

export interface VanillaReaderUiReadingRulerController extends IVanillaReaderUI {}

/**
 * # VanillaReaderUIReadingRuler
 *
 * ## RESPONSIBILITIES
 * This controller mixing class handles all event callbacks from the `VanillaReaderUIReadingRuler` class.
 *
 * Just as all other controller mixin classes, this class is used to add functionality to the `VanillaReaderUi` class
 * in a "modular" way. Read more about this in the `UI Components and Controller Mixins` in the README.md file.
 *
 * ## RELATED TYPES
 * - VanillaReaderUi
 * - VanillaReaderUiReadingRuler
 *
 */

export class VanillaReaderUiReadingRulerController {

    static __initialize__(vanillaReaderUiContext: VanillaReaderUI): void {
        vanillaReaderUiContext.readingRuler.onDragEnd(vanillaReaderUiContext._onReadingRulerDragEnd.bind(vanillaReaderUiContext));
        vanillaReaderUiContext.readingRuler.onVisible(vanillaReaderUiContext._onReadingRulerVisible.bind(vanillaReaderUiContext));
        vanillaReaderUiContext.readingRuler.onHidden(vanillaReaderUiContext._onReadingRulerHidden.bind(vanillaReaderUiContext));
        vanillaReaderUiContext.readingRuler.onClick(vanillaReaderUiContext._onReadingRulerClick.bind(vanillaReaderUiContext));
        vanillaReaderUiContext.readingRuler.onMoveEnd(vanillaReaderUiContext._onReadingRulerMoveEnd.bind(vanillaReaderUiContext));
    }

    _onReadingRulerDragEnd(_ev: PointerEvent, _rectData: IVisibleContentRectData): void {}

    _onReadingRulerVisible(): void {
        if(this.latestReadingPositionData) {
            this.moveReadingRulerToReadingPosition();
        }
    }

    _onReadingRulerHidden(): void {}

    _onReadingRulerMoveEnd(rectData: IVisibleContentRectData, affectReadingPosition: boolean = true): void {
        if(rectData.locator && affectReadingPosition) {
            let locator = `${rectData.locator.sourceUrl}#${rectData.locator.selectors[0]}`;
            if(affectReadingPosition && this.latestReadingPositionData?.locator !== locator) {
                this.navigateTo(locator);
            }
        }
    }

    _onReadingRulerClick(ev: MouseEvent): void {

        if(!this.readingRuler.snapToContentLineBoxes) {
            return;
        }

        if(ev.clientX > window.innerWidth / 2) {
            if(this.readingRuler.isAtEndOfContent) {
                this.navigateNext(true);
            } else {
                this.readingRuler.moveToNextContentLineBox(!this.useReducedMotion, false);
            }
        } else {
            if(this.readingRuler.isAtStartOfContent) {
                this.navigatePrevious(true);
            } else {
                this.readingRuler.moveToPreviousContentLineBox();
            }
        }
    }
}
